import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentQueue } from "../../../../../@types/attendance-local-department-queue";
import { AttendanceLocal } from "../../../../../@types/attendance-local";

export type AttendanceLocalDepartmentQueueCreateData = Pick<
    AttendanceLocalDepartmentQueue,
    | "setor"
    | "data_inicio"
    | "data_fim"
    | "ignorar_feriados"
    | "sabado"
    | "domingo"
> & {
    unidade: AttendanceLocal["slug_unidade"];
}

export function useAttendanceLocalDepartmentQueueCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        AttendanceLocalDepartmentQueue,
        AxiosError<{ detail: string; data_inicio: string; data_fim: string; }>,
        AttendanceLocalDepartmentQueueCreateData
    >({
        mutationKey: ["attendance-local", "department", "queue", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentQueueCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentQueue>(
                '/cms/fila_horarios/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Fila criada com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "department", "queue", "list"],
            });
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.detail
                || error?.response?.data?.data_inicio
                || error?.response?.data?.data_fim
                || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
